<template>
  <main class="the-filters">
    <div class="print-header">
      <img src="@/assets/img/mail_logo.png" alt="VAS SMR" />
      <p>
        <strong>Заработки за период:</strong>
        {{ formatedFromDate }} - {{ formatedToDate }}
      </p>
    </div>
    <p class="print-name" v-if="inquiry.worker._id">
      {{ inquiry.worker.name }}
    </p>

    <div class="inquiry-header">
      <template v-if="fromReports">
        <div class="own-reports-header">
          <template
            v-if="
              getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin
            "
          >
            <div class="types-toggles">
              <span
                class="type-toggle"
                :class="{ 'type-toggle--active': !showAllReports }"
                @click="$emit('selectReportsType', false)"
                >Моите отчети</span
              >

              <span
                class="type-toggle"
                :class="{ 'type-toggle--active': showAllReports }"
                @click="$emit('selectReportsType', true)"
                >Всички отчети</span
              >
            </div>
          </template>
          <template v-else>
            <h2 v-if="showAllReports">{{ $t("all-reports") }}</h2>
            <h2 v-else>{{ $t("my-last-reports") }}</h2>
          </template>
        </div>
      </template>
      <template v-else>
        <h2 v-if="!reports.length" class="desktop">
          {{ $t("inquiry-create") }}
        </h2>
        <h2 v-else class="desktop">{{ $t("inquiry-view") }}</h2>
      </template>

      <div class="inquiry-header-controlls" ref="top">
        <span class="inquiry-pre-datepicker-text desktop">{{
          $t("inquiry-period")
        }}</span>
        <div class="inquiry-datepicker" v-show="datePeriod !== 'all'">
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="tms">D</span>
              <input
                type="text"
                :placeholder="$t('date-from')"
                @click="openDropdown(0)"
                @focus="openDropdown(0)"
                @blur="closeDropdown(0)"
                v-model="formatedFromDate"
                readonly
              />
            </div>
          </div>
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="tms">D</span>
              <input
                type="text"
                :placeholder="$t('date-to')"
                @click="openDropdown(1)"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                v-model="formatedToDate"
                readonly
              />
            </div>
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active': openedDropdown[0] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="inquiry.fromDate"
              @selected="closeDropdown(0), changeDatePeriod('none')"
            ></datepicker>
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active': openedDropdown[1] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="inquiry.toDate"
              @selected="closeDropdown(1), changeDatePeriod('none')"
            ></datepicker>
          </div>
        </div>
        <div class="date-toggles">
          <span
            class="tms2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'current' }"
            @click="changeDatePeriod('current')"
            :title="$t('reports-for-current-month')"
            >X</span
          >
          <span
            class="tms2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'previous' }"
            @click="changeDatePeriod('previous')"
            :title="$t('reports-for-previous-month')"
            >Z</span
          >
          <span
            class="tms2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'half' }"
            @click="changeDatePeriod('half')"
            :title="$t('reports-for-six-months')"
            >V</span
          >
          <span
            class="tms2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'year' }"
            @click="changeDatePeriod('year')"
            :title="$t('reports-for-one-year')"
            >U</span
          >
          <span
            class="tms2 date-toggle"
            :class="{ 'date-toggle-active': datePeriod === 'all' }"
            @click="changeDatePeriod('all')"
            :title="$t('reports-for-all-times')"
            >W</span
          >
        </div>
      </div>
    </div>
    <div class="inquiry-filters">
      <div class="inquiry-filters-inputs">
        <!-- DESKTOP COMPANY  -->
        <div class="new-input-wrapper">
          <label>{{ $t("company") }}</label>
          <div class="new-input">
            <span class="tms">N</span>
            <!-- NOT SELECTED -->
            <input
              id="companyInput"
              v-if="!inquiry.company._id"
              type="text"
              :placeholder="$t('company')"
              @focus="getCompanies(), openDropdown(2)"
              @blur="closeDropdown(2)"
              v-model="searchCompanies"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              :placeholder="$t('company')"
              @focus="getCompanies(), openDropdown(2)"
              @blur="closeDropdown(2)"
              v-model="inquiry.company.companyName"
              :disabled="inquiry.company._id"
            />
            <span
              v-if="inquiry.company._id"
              class="clear"
              @click="resetSelectedCompany()"
              >F</span
            >
            <span
              @click.prevent="getCompanies(), focusInput('companyInput', 2)"
              class="arrow"
              v-else
              :class="{ 'arrow-reversed': openedDropdown[2] }"
              >K</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[2] }"
          >
            <!-- <ul> -->
            <span
              class="option"
              v-for="c in filteredCompanies()"
              :key="c._id"
              @mousedown="selectCompany(c), closeDropdown(2)"
              >{{ c.companyName }}</span
            >
            <!-- <li v-for="c in companies" :key="c._id">{{c.companyName}}</li> -->
            <!-- </ul> -->
          </div>
        </div>
        <!-- ОBJECT -->
        <div class="new-input-wrapper">
          <label>{{ $t("site") }}</label>
          <div class="new-input">
            <span class="tms">N</span>
            <!-- NOT SELECTED -->
            <input
              id="objectInput"
              v-if="!inquiry.object._id"
              type="text"
              :placeholder="$t('site')"
              @focus="getObjects(), openDropdown(4)"
              @blur="closeDropdown(4)"
              v-model="searchObjects"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              :placeholder="$t('site')"
              @focus="getObjects(), openDropdown(4)"
              @blur="closeDropdown(4)"
              v-model="inquiry.object.objectName"
              :disabled="inquiry.object._id"
            />
            <span
              v-if="inquiry.object._id"
              class="clear"
              @click="resetSelectedObject()"
              >F</span
            >
            <span
              @click.prevent="getObjects(), focusInput('objectInput', 4)"
              class="arrow"
              v-else
              :class="{ 'arrow-reversed': openedDropdown[4] }"
              >K</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[4] }"
          >
            <span
              class="option"
              v-for="o in filteredObjects()"
              :key="o._id"
              @mousedown="selectObject(o), closeDropdown(4)"
              >{{ o.objectName }}</span
            >
          </div>
        </div>
        <!-- PART -->
        <div class="new-input-wrapper">
          <label>{{ $t("part") }}</label>
          <div class="new-input">
            <span class="tms">N</span>
            <input
              id="partInput"
              v-if="!inquiry.part._id"
              type="text"
              :placeholder="$t('part')"
              @focus="getParts(), openDropdown(5)"
              @blur="closeDropdown(5)"
              v-model="searchParts"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              :placeholder="$t('part')"
              @focus="getParts(), openDropdown(5)"
              @blur="closeDropdown(5)"
              v-model="inquiry.part.partName"
              :disabled="inquiry.part._id"
            />
            <span
              v-if="inquiry.part._id"
              class="clear"
              @click="resetSelectedPart()"
              >F</span
            >
            <span
              @click.prevent="getParts(), focusInput('partInput', 5)"
              class="arrow"
              v-else
              :class="{ 'arrow-reversed': openedDropdown[5] }"
              >K</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[5] }"
          >
            <span
              class="option"
              v-for="p in filteredParts()"
              :key="p._id"
              @mousedown="selectPart(p), closeDropdown(5)"
              >{{ p.partName }}</span
            >
          </div>
        </div>
        <!-- MDM -->
        <div class="new-input-wrapper">
          <label>{{ $t("mdm") }}</label>
          <div class="new-input">
            <span class="tms">N</span>
            <input
              id="mdnInput"
              type="text"
              :placeholder="$t('mdm')"
              @focus="openDropdown(6), getMDM()"
              @blur="closeDropdown(6)"
              @keyup="getMDM()"
              v-model="inquiry.search"
              :disabled="isInquiryMade"
            />

            <span v-if="isInquiryMade" class="disabled">A</span>
            <span
              @click.prevent="getMDM(), focusInput('mdnInput', 6)"
              class="arrow"
              v-else
              :class="{ 'arrow-reversed': openedDropdown[6] }"
              >K</span
            >
            <span
              v-if="inquiry.search && !isInquiryMade"
              class="clear"
              @click="(inquiry.search = ''), reset()"
              >F</span
            >
          </div>
          <div
            class="new-input-dropdown"
            :class="{ 'new-input-dropdown-active': openedDropdown[6] }"
          >
            <span
              class="option"
              v-for="(x, i) in mdm"
              :key="`mdm-${i}`"
              @mousedown="(inquiry.search = x), closeDropdown(6)"
              >{{ x }}</span
            >
          </div>
        </div>
        <!-- WORKER -->

        <section class="users-inputs-wrapper" v-if="!fromReports">
          <!-- USERS TYPES dropdown -->
          <div
            class="new-input-wrapper new-input-wrapper--big"
            :class="{ 'new-input-wrapper--disabled': notAdminOrSuperAdmin }"
          >
            <div class="new-input new-input--user">
              <input
                id="userTypesInput"
                type="text"
                :placeholder="$t('user-types')"
                :disabled="notAdminOrSuperAdmin"
                @focus="openDropdown(7)"
                @blur="closeDropdown(7)"
                v-model="searchUsersTypes"
              />

              <span
                v-if="!notAdminOrSuperAdmin"
                @click.prevent="focusInput('userTypesInput', 7)"
                class="arrow"
                :class="{ 'arrow-reversed': openedDropdown[7] }"
                >K</span
              >
            </div>
            <div
              class="new-input-dropdown"
              :class="{
                'new-input-dropdown-active new-input-dropdown-active--fit-content':
                  openedDropdown[7],
              }"
            >
              <div
                class="option option--checkbox"
                :class="{
                  'option--disabled':
                    activeTab === 5 && wi !== 0 && wi !== 3 && wi !== 4,
                }"
                v-for="(w, wi) in filteredUsersTypes()"
                :key="w._id"
                @mousedown="selectUsersType(w, false, wi), closeDropdown(7)"
              >
                <Checkbox
                  :value="selectedUsersType[w.name]"
                  :label="
                    selectedUsersType[w.name] && w.name === $t('select-all')
                      ? $t('remove-all')
                      : w.name
                  "
                />
              </div>
            </div>
          </div>
          <!-- USERS TYPES dropdown -->

          <!-- USERS dropdown -->
          <div
            class="new-input-wrapper new-input-wrapper--big"
            :class="{ 'new-input-wrapper--disabled': notAdminOrSuperAdmin }"
          >
            <div class="new-input">
              <span class="tms">N</span>
              <input
                id="selectedUserTypesInput"
                v-if="!inquiry.worker._id"
                type="text"
                :placeholder="
                  !Object.entries(selectedUsersType).length
                    ? $t('select-users-type')
                    : $t('search-in') + getSelectedUsersType()
                "
                @focus="openDropdown(8)"
                @blur="closeDropdown(8)"
                v-model="searchAllUsers"
                :disabled="
                  inquiry.reporter._id.length > 0 ||
                  !Object.entries(selectedUsersType).length ||
                  notAdminOrSuperAdmin
                "
              />
              <!-- SELECTED -->
              <input
                v-else
                type="text"
                :placeholder="$t('search-in') + getSelectedUsersType()"
                @focus="openDropdown(8)"
                @blur="closeDropdown(8)"
                :value="inquiry.worker.name"
                :disabled="
                  inquiry.reporter._id.length > 0 ||
                  inquiry.worker._id ||
                  !Object.entries(selectedUsersType).length ||
                  notAdminOrSuperAdmin
                "
              />

              <span
                v-if="!notAdminOrSuperAdmin"
                @click.prevent="focusInput('selectedUserTypesInput', 8)"
                class="arrow"
                :class="{ 'arrow-reversed': openedDropdown[8] }"
                >K</span
              >

              <span
                v-if="inquiry.worker._id && !notAdminOrSuperAdmin"
                class="clear"
                @click="resetSelectedUser()"
                >F</span
              >
              <span v-if="inquiry.reporter._id.length > 0" class="disabled"
                >A</span
              >
            </div>
            <div
              class="new-input-dropdown"
              :class="{ 'new-input-dropdown-active': openedDropdown[8] }"
            >
              <div
                class="option"
                v-for="w in filteredAllUsers()"
                :key="w._id"
                @mousedown="selectUser(w), closeDropdown(8)"
              >
                <span class="tms tms--role tms--blue" v-if="w.permissions"
                  >y</span
                >
                <span class="tms tms--role tms--brown" v-if="w.isWorkerGroup"
                  >1</span
                >
                <span v-if="w.isWorkerGroup">{{ w.worker.name }} - </span>
                <span
                  class="tms tms--role tms--blue"
                  v-if="!w.permissions && !w.isWorkerGroup"
                  >0</span
                >
                <span>{{ w.name }}</span>
              </div>
            </div>
          </div>
          <!-- USERS dropdown -->
        </section>
      </div>
      <div class="inquiry-filters-btns">
        <div class="flag-toggles">
          <p>{{ $t("amounts-entered") }}</p>
          <div
            class="flag-toggle"
            :class="{ 'flag-toggle-active': inquiry.priceStatus === 0 }"
            @click="selectPriceStatus(0)"
          >
            <img
              class="flag-indicator"
              src="@/assets/img/red.svg"
              :alt="$t('no-amounts-entered')"
              :title="$t('no-amounts-entered')"
            />
          </div>
          <div
            class="flag-toggle"
            :class="{ 'flag-toggle-active': inquiry.priceStatus === 1 }"
            @click="selectPriceStatus(1)"
          >
            <img
              class="flag-indicator"
              src="@/assets/img/yellow.svg"
              :alt="$t('missing-amounts-entered')"
              :title="$t('missing-amounts-entered')"
            />
          </div>
          <div
            class="flag-toggle"
            :class="{ 'flag-toggle-active': inquiry.priceStatus === 2 }"
            @click="selectPriceStatus(2)"
          >
            <img
              class="flag-indicator"
              src="@/assets/img/green.svg"
              :alt="$t('all-amounts-entered')"
              :title="$t('all-amounts-entered')"
            />
          </div>
        </div>
        <div class="checkboxes-wrapper">
          <Checkbox
            v-model="activeObjects"
            @input="selectActiveObjects()"
            :label="$t('active-sites')"
          />
          <Checkbox
            v-model="inquiry.isInvalid"
            @input="selectInvalid()"
            :label="$t('invalid-reports')"
          />
        </div>
        <!-- DESKTOP BUTTONS -->
        <button
          v-show="!reports.length"
          class="btn btn-new"
          @click="$emit('getInquiry')"
        >
          <span v-if="fromReports">Търси в отчети</span>
          <span v-else>{{ $t("make-inquiry") }}</span>
        </button>
        <div v-show="reports.length" class="btns desktop">
          <!-- @click="exportFile()" -->
          <button
            class="btn btn-print"
            @click="print()"
            v-if="inquiry.worker._id && activeTab === 5"
          >
            <img src="@/assets/img/print.png" alt="print" />
            Печат
          </button>

          <button
            class="btn btn-excel"
            @click="$emit('exportToExcelFile')"
            ref="excelBtn"
          >
            <span class="tms">E</span>
            {{ $t("export-to-excel") }}
          </button>
          <button
            class="btn btn-reset"
            @click="$emit('resetInquiry'), resetInquiry()"
          >
            <span class="tms">F</span>
            {{ $t("reset-filters") }}
          </button>
        </div>
      </div>
    </div>

    <div class="inquiry-title-wrapper" v-if="isInquiryMade">
      <h3
        class="inquiry-title"
        :class="{ 'inquiry-title-invalid': !activeObjects }"
        ref="reports"
      >
        <span>{{ $t("inquiry") }}&nbsp;</span>
        <span v-if="inquiry.company._id">
          <span>{{ $t("inquiry-for-company") }}&nbsp;</span>
          <strong>{{ inquiry.company.companyName }}&nbsp;</strong>
        </span>
        <span v-else>
          <span>
            {{ $t("inquiry-for") }}
            <template v-if="inquiry.isInvalid"
              >{{ $t("inquiry-invalid") }}&nbsp;</template
            >
            {{ $t("inquiry-reports-for") }}&nbsp;
          </span>
          <strong>
            {{ $t("inquiry-all") }}
            <template v-if="!activeObjects"
              >{{ $t("inquiry-inactive") }}&nbsp;</template
            >
            {{ $t("companies").toLowerCase() }}&nbsp;
          </strong>
        </span>
        <!-- <span v-if="inquiry.project._id">
          <span>{{ $t('project').toLowerCase() }}&nbsp;</span>
          <strong>{{inquiry.project.projectName}}&nbsp;</strong>
        </span> -->
        <span v-if="inquiry.object._id">
          <span>{{ $t("site").toLowerCase() }}&nbsp;</span>
          <strong>{{ inquiry.object.objectName }}&nbsp;</strong>
        </span>
        <span v-if="inquiry.part._id">
          <span>{{ $t("part").toLowerCase() }}&nbsp;</span>
          <strong>{{ inquiry.part.partName }}&nbsp;</strong>
        </span>
        <span v-if="inquiry.reporter._id">
          <span>{{ $t("reporter").toLowerCase() }}&nbsp;</span>
          <strong>{{ inquiry.reporter.name }}&nbsp;</strong>
        </span>
        <span v-if="inquiry.worker._id">
          за
          <span v-if="inquiry.worker.isWorkerGroup"
            >{{ $t("users-workers-group").toLowerCase() }}&nbsp;</span
          >
          <span
            v-else-if="!inquiry.worker.isWorkerGroup && inquiry.worker.users"
            >{{ $t("group").toLowerCase() }}&nbsp;</span
          >
          <span v-else>служител ВАС&nbsp;</span>
          <strong>{{ inquiry.worker.name }}&nbsp;</strong>
        </span>
        <span v-if="inquiry.priceStatus === 0">
          <strong>{{ $t("inquiry-no-amounts") }}</strong>
        </span>
        <span v-if="inquiry.priceStatus === 1">
          <strong>{{ $t("inquiry-missing-amounts") }}</strong>
        </span>
        <span v-if="inquiry.priceStatus === 2">
          <strong>{{ $t("inquiry-all-amounts") }}</strong>
        </span>
      </h3>
      <h3
        class="inquiry-title"
        v-if="inquiry.search"
        :class="{ 'inquiry-title-invalid': !activeObjects }"
      >
        {{ $t("inquiry-mdm") }} -
        <strong>{{ inquiry.search }}</strong>
      </h3>
      <h3
        class="inquiry-title"
        :class="{ 'inquiry-title-invalid': !activeObjects }"
      >
        <template v-if="datePeriod !== 'all'">
          <span>{{ $t("inquiry-period-from") }}&nbsp;</span>
          <strong>{{ formatedFromDate }}</strong>
          <span>&nbsp;{{ $t("inquiry-period-to") }}&nbsp;</span>
          <strong>{{ formatedToDate }}</strong>
        </template>
        <template v-else>
          <span>
            {{ $t("inquiry-period-for") }}
            <strong>{{ $t("inquiry-period-all") }}</strong>
          </span>
        </template>
      </h3>
    </div>
    <div v-if="!isInquiryMade" class="no-reports">
      <p>
        {{ $t("inquiry-select-filters") }}
        {{ fromReports ? "Търси в отчети" : `${$t("make-inquiry")}` }}
      </p>
    </div>
  </main>
</template>

<script>
import Checkbox from "./Checkbox.vue";
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";
import { mapGetters } from "vuex";
export default {
  props: [
    "inquiry",
    "isInquiryMade",
    "activeTab",
    "reports",
    "queryObject",
    "fromReports",
    "showAllReports",
  ],
  components: {
    Checkbox,
    Datepicker,
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      "getLoading",
      // ...
    ]),
    notAdminOrSuperAdmin() {
      return (
        !this.getUser.permissions.isSuperAdmin &&
        !this.getUser.permissions.isAdmin
      );
    },
  },
  watch: {
    activeTab() {
      if (this.activeTab === 5) {
        // selects only vas-users and workers groups
        this.resetUsersType();
        setTimeout(() => {
          this.selectUsersType(this.filteredUsersTypes()[5]);
          this.selectUsersType(this.filteredUsersTypes()[0]);
          this.selectUsersType(this.filteredUsersTypes()[4]);
          this.selectUsersType(this.filteredUsersTypes()[3]);
        }, 100);
      } else if (this.activeTab === 4) {
        this.selectUsersType(this.filteredUsersTypes()[5]);
        this.selectUsersType(this.filteredUsersTypes()[4]);
        this.selectUsersType(this.filteredUsersTypes()[3]);
      } else {
        this.selectUsersType(this.filteredUsersTypes()[5]);
      }
    },
    "inquiry.fromDate"(to, from) {
      // eslint-disable-next-line
      if (!!from) {
        this.reset();
      }
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      this.queryObject.fromDate = this.inquiry.fromDate.toISOString();
      this.formatedFromDate = format(new Date(this.inquiry.fromDate), 'dd/MM/yyyy');
      
      this.$emit("setFormatedFromDate", this.formatedFromDate);
    },
    "inquiry.toDate"(to, from) {
      // eslint-disable-next-line
      if (!!from) {
        this.reset();
      }
      this.inquiry.toDate.setHours(23, 59, 59, 999);
      this.queryObject.toDate = this.inquiry.toDate.toISOString();
      this.formatedToDate = format(new Date(this.inquiry.toDate), 'dd/MM/yyyy');

      this.$emit("setFormatedToDate", this.formatedToDate);
    },
  },
  data() {
    return {
      bg: bg,
      datePeriod: "current",
      searchCompanies: "",
      searchObjects: "",
      searchParts: "",
      searchAllUsers: "",
      searchUsersTypes: "",
      selectedUsersType: {},
      companies: [],
      objects: [],
      parts: [],
      mdm: [],
      formatedFromDate: null,
      formatedToDate: null,
      activeObjects: true,
      openedDropdown: [false, false, false, false, false, false, false, false],
      usersTypes: [
        { name: this.$t("users-vas"), value: "users-vas" },
        { name: this.$t("reporters"), value: "isReporter" },
        { name: this.$t("users-groups"), value: "groups" },
        { name: this.$t("workers-groups"), value: "workers-groups" },
        { name: this.$t("users-workers-groups"), value: "isWorkerGroup" },
        { name: this.$t("select-all"), value: "all" },
      ],
    };
  },
  methods: {
    reset() {
      (this.searchCompanies = ""),
        (this.searchObjects = ""),
        (this.searchParts = ""),
        (this.searchAllUsers = ""),
        (this.searchUsersTypes = ""),
        this.$emit("reset");
    },
    getUrl() {
      // this.inquiry.search = this.inquiry.search.replace('/', '');

      let url = `${process.env.VUE_APP_BASE_URI}/report/inquiry`;
      url += `/${this.inquiry.company._id ? this.inquiry.company._id : 0}`;
      // url += `/${this.inquiry.project._id ? this.inquiry.project._id : 0}`;
      url += `/${this.inquiry.object._id ? this.inquiry.object._id : 0}`;
      url += `/${this.inquiry.part._id ? this.inquiry.part._id : 0}`;
      url += `/${this.inquiry.reporter._id ? this.inquiry.reporter._id : 0}`;
      url += `/${this.inquiry.worker._id ? this.inquiry.worker._id : 0}`;
      url += `/${this.inquiry.fromDate.toISOString()}`;
      url += `/${this.inquiry.toDate.toISOString()}`;
      url += `/${this.inquiry.isInvalid}`;
      url += `/${this.activeObjects}`;
      url += `/${this.inquiry.priceStatus}`;
      url += `/${
        this.inquiry.search ? encodeURIComponent(this.inquiry.search) : null
      }`;
      return url;
    },
    getMDM() {
      if (
        this.inquiry.company._id &&
        this.inquiry.object._id &&
        this.inquiry.part._id
      ) {
        this.$http.get(this.getUrl() + "?mdm=true").then((response) => {
          this.mdm = response.data;
        });
      }
    },
    filteredAllUsers() {
      if (this.openedDropdown[8]) {
        if (this.allUsers.length) {
          return this.allUsers.filter((w) => {
            const x = w.isWorkerGroup ? `${w.worker.name} - ${w.name}` : w.name;
            return x.toLowerCase().includes(this.searchAllUsers.toLowerCase());
          });
        }
      }
    },
    filteredCompanies() {
      if (this.companies.length) {
        return this.companies.filter((c) => {
          return c.companyName
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      }
    },
    filteredUsersTypes() {
      return this.usersTypes.filter((w) => {
        return w.name
          .toLowerCase()
          .includes(this.searchUsersTypes.toLowerCase());
      });
    },
    filteredObjects() {
      if (this.objects.length) {
        return this.objects.filter((o) => {
          return o.objectName
            .toLowerCase()
            .includes(this.searchObjects.toLowerCase());
        });
      }
    },
    filteredParts() {
      if (this.parts.length) {
        return this.parts.filter((p) => {
          return p.partName
            .toLowerCase()
            .includes(this.searchParts.toLowerCase());
        });
      }
    },
    selectUser(w) {
      this.reset();
      if (w.isWorkerGroup) w.name = `${w.worker.name} - ${w.name}`;
      this.inquiry.worker = w;
      this.queryObject.worker = w._id;
      this.queryObject.workerName = w.name;
      this.closeDropdown(8);
    },
    selectPriceStatus(p) {
      this.reset();
      if (p === this.inquiry.priceStatus) {
        this.inquiry.priceStatus = null;
      } else {
        this.inquiry.priceStatus = p;
      }
      this.queryObject.status = p;
      this.$router.push({ query: this.queryObject }).catch((err) => err);
    },
    getSelectedUsersType() {
      return Object.keys(this.selectedUsersType).map((s) => s);
    },
    getCompanies() {
      let url = "";
      if (this.getUser.permissions.isAdmin) {
        url = `${process.env.VUE_APP_BASE_URI}/company/`;
      } else if (this.getUser.permissions.isReporter) {
        url = `${process.env.VUE_APP_BASE_URI}/company/reporters/companies/${this.getUser._id}`;
      } else {
        this.$snotify.error(this.$t("no-permissions"));
      }

      return this.$http
        .get(url)
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => console.log(error));
    },
    getObjects() {
      this.objects = [];
      if (this.inquiry.company._id) {
        let url = "";

        if (this.getUser.permissions.isAdmin) {
          url = `${process.env.VUE_APP_BASE_URI}/company/object-names/${
            this.inquiry.company._id
          }?active=${this.activeObjects ? "true" : "false"}`;
        } else if (this.getUser.permissions.isReporter) {
          url = `${process.env.VUE_APP_BASE_URI}/company/reporters/objects/${this.inquiry.company._id}/${this.getUser._id}`;
        } else {
          this.$snotify.error(this.$t("no-permissions"));
        }

        return this.$http
          .get(url)
          .then((response) => {
            this.objects = response.data;
          })
          .catch((error) => console.log(error.response));
      }
    },
    getParts() {
      this.parts = [];
      if (this.inquiry.object._id) {
        let url = "";

        if (this.getUser.permissions.isAdmin) {
          url = `${process.env.VUE_APP_BASE_URI}/company/part-names/${
            this.inquiry.company._id
          }/${this.inquiry.object._id}?active=${
            this.activeObjects ? "true" : "false"
          }`;
        } else if (this.getUser.permissions.isReporter) {
          url = `${process.env.VUE_APP_BASE_URI}/company/reporters/parts/${this.inquiry.company._id}/${this.inquiry.object._id}/${this.getUser._id}`;
        } else {
          this.$snotify.error(this.$t("no-permissions"));
        }

        return this.$http
          .get(url)
          .then((response) => {
            this.parts = response.data;
          })
          .catch((error) => console.log(error.response));
      }
    },
    openDropdown(i) {
      if ((i === 7 || i === 8) && this.notAdminOrSuperAdmin) {
        return this.$snotify.warning(
          `Само ${this.$t("users-superadmin")} или ${this.$t(
            "users-admin"
          )} могат да избират вид потребители`
        );
      }
      this.$set(this.openedDropdown, i, true);
    },
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    selectCompany(c) {
      this.reset();
      this.inquiry.company = c;
      this.queryObject.company = c._id;
      this.queryObject.companyName = c.companyName;
    },
    selectObject(o) {
      this.reset();
      this.inquiry.object = o;
      this.queryObject.object = o._id;
      this.queryObject.objectName = o.objectName;
    },
    selectPart(p) {
      this.reset();
      this.inquiry.part = p;
      this.queryObject.part = p._id;
      this.queryObject.partName = p.partName;
    },
    resetSelectedCompany() {
      this.inquiry.company = {
        _id: "",
        companyName: "",
      };
      this.company = "";
      delete this.queryObject.company;
      delete this.queryObject.companyName;
      this.resetSelectedObject();
    },
    resetSelectedObject() {
      this.inquiry.object = {
        _id: "",
        objectName: "",
      };
      this.object = "";
      delete this.queryObject.object;
      delete this.queryObject.objectName;
      this.resetSelectedPart();
    },
    resetSelectedPart() {
      this.reset();
      this.inquiry.part = {
        _id: "",
        partName: "",
      };
      this.part = "";
      delete this.queryObject.part;
      delete this.queryObject.partName;
    },
    // resetSelectedReporter() {
    //   this.reset();
    //   this.inquiry.reporter = {
    //     _id: "",
    //     name: "",
    //   };
    //   this.reporter = "";
    //   delete this.queryObject.reporter;
    //   delete this.queryObject.reporterName;
    // },
    resetSelectedUser() {
      this.reset();
      this.inquiry.worker = {
        _id: "",
        name: "",
      };
      this.searchAllUsers = "";
      this.reporter = "";
      delete this.queryObject.worker;
      delete this.queryObject.workerName;
    },
    resetUsersType() {
      this.selectUsersType({ name: this.$t("select-all") }, true);
    },
    resetInquiry() {
      this.resetUsersType();
      // this.reports = [];
      // this.isInquiryMade = false;
      this.resetSelectedCompany();
      if (
        this.getUser.permissions.isSuperAdmin ||
        this.getUser.permissions.isAdmin
      ) {
        // this.resetSelectedReporter();
        this.resetSelectedUser();
      }
      this.selectPriceStatus(null);
      this.changeDatePeriod("current");
      this.activeObjects = true;
      this.$emit("setActiveObjects", true);
      this.inquiry.isInvalid = false;
      this.inquiry.search = "";
    },
    selectActiveObjects() {
      this.reset();
      this.resetSelectedCompany();
      this.queryObject.active = this.activeObjects;
      this.$emit("setActiveObjects", this.activeObjects);
    },
    selectInvalid() {
      this.reset();
      this.queryObject.isInvalid = this.inquiry.isInvalid;
    },
    selectUsersType(t, reset, index) {
      if (
        this.activeTab === 5 &&
        index &&
        index !== 0 &&
        index !== 3 &&
        index !== 4
      ) {
        return this.$snotify.error(
          `Само ${this.$t("users-vas")} и ${this.$t(
            "users-workers-groups"
          )} са възможни като опция при избран таб "Заработки" `
        );
      }

      if (t.name === this.$t("select-all")) {
        // select / deselect all
        if (this.selectedUsersType[t.name] && !reset) {
          this.usersTypes.forEach((x) => delete this.selectedUsersType[x.name]);
        } else {
          this.usersTypes.forEach(
            (x) => (this.selectedUsersType[x.name] = x.value)
          );
        }
      } else {
        if (this.selectedUsersType[t.name])
          delete this.selectedUsersType[t.name];
        else this.selectedUsersType[t.name] = t.value;
      }
      this.getAllUsers();
    },
    async getAllUsers() {
      let filterBy = Object.values(this.selectedUsersType);

      let users = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/auth/users?noReporters=true`
      );
      let reporters = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/auth/users/reporters`
      );
      let workerGroups = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/group?workerGroups=true`
      );
      let groups = await this.$http.get(
        `${process.env.VUE_APP_BASE_URI}/group?notEmpty=true`
      );

      this.allUsers = [];
      if (filterBy.includes("users-vas")) {
        this.allUsers.push(
          ...users.data.filter((u) => !u.permissions.isWorker)
        );
      }
      if (filterBy.includes("workers-groups")) {
        this.allUsers.push(...users.data.filter((u) => u.permissions.isWorker));
      }
      if (filterBy.includes("isReporter"))
        this.allUsers.push(...reporters.data);
      if (filterBy.includes("groups")) this.allUsers.push(...groups.data);
      if (filterBy.includes("isWorkerGroup"))
        this.allUsers.push(...workerGroups.data);
      this.allUsers = this.allUsers.sort((a, b) => {
        const x =
          a.isWorkerGroup && a.worker ? `${a.worker.name} - ${a.name}` : a.name;
        const y =
          b.isWorkerGroup && b.worker ? `${b.worker.name} - ${b.name}` : b.name;
        return x.toLowerCase() > y.toLowerCase() ? 1 : -1;
      });
    },
    focusInput(id, dropdownNum) {
      let input = document.getElementById(id);
      if (this.openedDropdown[dropdownNum]) {
        input.blur();
      } else {
        input.focus();
      }
    },
    print() {
      window.print();
    },
    changeDatePeriod(p) {
      this.datePeriod = p;
      if (p === "current") {
        this.setDates(0, -1);
      } else if (p === "previous") {
        this.setDates(1, 0);
      } else if (p === "half") {
        this.setDates(6, -1);
      } else if (p === "year") {
        this.setDates(12, -1);
      } else if (p === "all") {
        this.setDates(12000, -12000);
      }
      this.queryObject.period = p;
      this.$router.push({ query: this.queryObject }).catch((err) => err);
    },
    setDates(from, to) {
      const date = new Date();
      // set first day of previous month
      this.inquiry.fromDate = new Date(
        date.getFullYear(),
        date.getMonth() - from,
        1
      );
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.inquiry.toDate = new Date(
        date.getFullYear(),
        date.getMonth() + to * -1,
        0
      );
      this.inquiry.toDate.setHours(23, 59, 59, 999);
    },
  },
  mounted() {
    this.setDates(0, -1);
    this.resetUsersType();
    if (this.notAdminOrSuperAdmin) {
      this.selectUser(this.getUser);
    }
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.the-filters {
  .mobile,
  .print-header,
  .print-name {
    display: none;
  }
  .own-reports-header {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  .inquiry-header {
    align-items: center;
    display: flex;
    height: 36px;
    justify-content: space-between;

    .inquiry-header-controlls {
      align-items: center;
      display: flex;
      .btns {
        align-items: center;
      }
    }
    .inquiry-pre-datepicker-text {
      color: #373737;
      display: inline-block;
      font-size: 11px;
      font-weight: 700;
      margin-right: 20px;
    }
    .inquiry-datepicker {
      border-radius: 4px;
      display: flex;
      position: relative;
      width: 330px;
      padding: 10px 0;
    }
    .inquiry-datepicker .new-input-wrapper {
      background-color: #104d8033;
      margin: 0;
      width: 50%;
    }
    .inquiry-datepicker .new-input-wrapper:first-child {
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
    }
    .inquiry-datepicker .new-input-wrapper:nth-child(2) {
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }
    .inquiry-datepicker .new-input {
      background-color: transparent;
      margin: 0;
    }
    .inquiry-datepicker .new-input input {
      background-color: transparent;
      border: 1px solid #104d8033;
      height: 36px;
      cursor: pointer;
    }
    .inquiry-datepicker .new-input input:focus {
      background-color: #fff;
      border: 1px solid #104d8033;
    }
  }
  .inquiry-filters {
    background-color: #104d8033;
    border-radius: 4px;
    margin-top: 10px;
    padding: 10px 25px 15px;

    .inquiry-filters-inputs {
      align-items: flex-end;
      display: flex;
      gap: 20px;
      .new-input-wrapper:last-child {
        margin-right: 0;
      }
    }
  }
  .inquiry-filters-btns {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    position: relative;
  }
  .inquiry-filters-btns .checkboxes {
    display: flex;
  }
  .checkboxes-wrapper {
    display: flex;
    gap: 15px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .inquiry-filters-btns .btn {
    margin: 0;
  }
  .inquiry-filters-btns .btn-print,
  .inquiry-filters-btns .btn-excel {
    margin-right: 10px;
  }
  .date-toggles,
  .flag-toggles {
    align-items: center;
    display: flex;
  }
  .date-toggle,
  .flag-toggle {
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #104d8033;
    border-radius: 4px;
    color: #0058bc;
    cursor: pointer;
    font-size: 24px;
    display: inline-flex;
    height: 36px;
    justify-content: center;
    margin-left: 10px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 36px;
  }
  .flag-toggles p {
    margin-right: 10px;
  }
  .flag-toggle img {
    width: 24px;
  }
  .date-toggle:hover,
  .flag-toggle:hover {
    border-color: rgba(77, 77, 77, 0.2);
  }
  .date-toggle-active,
  .flag-toggle-active,
  .date-toggle-active:hover,
  .flag-toggle-active:hover {
    background-color: rgb(214, 232, 252);
    border-color: #0058bc;
  }

  .inquiry-title-wrapper {
    padding: 30px 20px 20px;

    .inquiry-title {
      color: #0058bc;
      font-size: 18px;
      font-weight: 400;
      text-align: center;
      width: 100%;
    }
    .inquiry-title-invalid {
      color: #bf392a;
    }
  }
  .no-reports {
    /* background-color: #fff; */
    /* border-radius: 4px; */
    padding: 20px;
    text-align: center;
    width: 100%;
  }
}

@media screen and (max-width: 1200px) {
  .the-filters {
    .checkboxes-wrapper {
      position: static;
      transform: initial;
    }
  }
}
@media screen and (max-width: 1000px) {
  .the-filters {
    .inquiry-filters {
      .inquiry-filters-inputs {
        gap: 0;

        .new-input {
          margin: 5px 0;
        }
      }
    }
    .desktop {
      display: none !important;
    }

    .mobile {
      display: inline-grid;
    }

    .inquiry-header {
      height: initial;
      flex-direction: column;
      gap: 15px;
      .inquiry-datepicker {
        gap: 5px;
        justify-content: space-between;
        width: 100%;
        .new-input-wrapper {
          width: calc(50% - 5px);
        }
      }
    }
    .inquiry-header-controlls {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      width: 100%;
    }

    .date-toggle {
      margin: 0 5px;
    }
    .inquiry-pre-datepicker-text {
      font-size: 20px;
    }
    .inquiry-filters {
      padding: 10px;
      margin-top: 0;
    }
    .inquiry-filters-inputs {
      display: flex;
      flex-direction: column;
    }
    .inquiry-filters-btns {
      flex-direction: column;
      gap: 10px;
    }
    .new-input-wrapper,
    .users-inputs-wrapper {
      margin-right: 0;
      width: 100%;
    }
    .checkboxes-wrapper {
      margin: 5px 0;
    }
  }
}

@media print {
  .the-filters {
    .inquiry-header,
    .inquiry-filters,
    .inquiry-title-wrapper,
    .reports-tabs,
    .print-hide,
    .switch-wrapper {
      display: none;
    }
    .print-header {
      align-items: center;
      background-color: #f6f6f6;
      border-radius: 10px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 15px 22px;
    }
    .print-name {
      display: block;
      font-size: 16px;
      padding: 15px;
      text-align: center;
    }
  }
}
</style>
